import React from 'react';

export default function LoadingSpinner({ size = 'md', message = 'Loading...' }) {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className={`${sizeClasses[size]} border-4 border-white/20 border-t-primary rounded-full animate-spin`}></div>
      {message && <p className="mt-3 text-gray-400 text-sm">{message}</p>}
    </div>
  );
}
